import { IBaseCellsProps } from '../../cells.interfaces';
import { StyledTableCell } from './CellPersonSkeleton.styles';
import { Box, Skeleton } from '../../../../base-components';

const CellPersonSkeleton = (props: IBaseCellsProps) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
    } = props;

    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
        >
            <Box display="flex" alignItems="center" gap={1}>
                <Skeleton variant="circular" width={30} height={30} />
                <Skeleton width={100} variant="text" />
            </Box>
        </StyledTableCell>
    );
};

export default CellPersonSkeleton;
